import React from 'react';
import styled from '@emotion/styled';
import dayjs from 'dayjs';
import { mqUser } from 'utils/responsive';

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    border-radius: 10px;
    overflow: hidden;
    background-color: var(--white);
    margin-top: 20px;
`;

const TableHeader = styled.th`
    padding: 12px;
    background-color: var(--main-font-color);
    border: 1px solid var(--gray);
    text-align: left;
    color: var(--white);
    font-size: var(--font-medium);
    font-weight: var(--font-bold);

    ${mqUser('SP')} {
        padding: 8px;
        font-size: var(--font-small);
    }
`;

const TableRow = styled.tr`
    &:nth-of-type(even) {
        background-color: var(--light-gray);
    }

    &:hover {
        background-color: #f0f0f0;
    }
`;

const TableCell = styled.td`
    padding: 12px;
    border: 1px solid #e0e0e0;
    font-size: var(--font-medium);

    ${mqUser('SP')} {
        padding: 8px;
        font-size: var(--font-small);
    }
`;

const EmptyMessage = styled.div`
    text-align: center;
    padding: 40px;
    color: #666;
    font-size: var(--font-medium);
`;

interface InvitedEmail {
    id: number;
    email: string;
    type: 'seller' | 'buyer';
    invitedAt: string;
    status: string;
}

interface InvitationTableProps {
    invitedEmails: InvitedEmail[];
}

export const InvitationTable: React.FC<InvitationTableProps> = ({ invitedEmails }) => {
    return (
        <Table>
            <thead>
                <tr>
                    <TableHeader>メールアドレス</TableHeader>
                    <TableHeader>種別</TableHeader>
                    <TableHeader>招待日</TableHeader>
                    <TableHeader>ステータス</TableHeader>
                </tr>
            </thead>
            <tbody>
                {invitedEmails.length === 0 ? (
                    <tr>
                        <TableCell colSpan={4}>
                            <EmptyMessage>招待中のメールアドレスはありません</EmptyMessage>
                        </TableCell>
                    </tr>
                ) : (
                    invitedEmails.map((item) => (
                        <TableRow key={item.id}>
                            <TableCell>{item.email}</TableCell>
                            <TableCell>{item.type === 'seller' ? '売り手' : '買い手'}</TableCell>
                            <TableCell>{item.invitedAt ? dayjs(item.invitedAt).format('YYYY/MM/DD') : '-'}</TableCell>
                            <TableCell>
                                <span style={{ color: '#ff9800' }}>招待中</span>
                            </TableCell>
                        </TableRow>
                    ))
                )}
            </tbody>
        </Table>
    );
};
